import Breadcrumb from "../../../components/breadcrumb";

export default function CompararHeader() {
    return (
        <header className="mb-6 sm:mb-8">
            <Breadcrumb
                items={[
                    { label: "Inicio", to: "/" },
                    { label: "Comparar", isCurrent: true },
                ]}
                className="mb-4"
            />

            <div>
                <h1 className="text-3xl sm:text-4xl md:text-5xl font-black tracking-tight text-white mb-2 sm:mb-3 border-l-4 border-red-500 pl-3 sm:pl-4 leading-tight">Comparar</h1>
                <p className="text-slate-400 font-medium text-base sm:text-lg max-w-3xl pl-3 sm:pl-4">Comparación estadística entre dos jugadores o técnicos de Aguada.</p>
            </div>
        </header>
    );
}